<template>
  <b-overlay 
    :show="busy" 
    variant="dark"
  >
    <b-card 
      v-if="parsing" 
      no-body
    >
      <b-card-header>
        <b-card-title>
          Docparsing <small>{{ $route.params.id }}</small>
        </b-card-title>
      </b-card-header>
      <b-card-group>
        <b-card>
          <b-card-body>
            <b-button
              :disabled="unit == null"
              :variant="unit == null ? 'secondary' : 'primary'"
              class="pull-right"
              @click="overnemenresultaat"
            >
              Overnemen datum en keuringstatus <font-awesome-icon icon="arrow-down" />
            </b-button>
            <b-button-toolbar class="mb-3">
              <b-input-group prepend="Keuringsdatum">
                <b-input-group-text dark>
                  {{
                    parsing.ParsedPayload.keuringsdatum ? moment(parsing.ParsedPayload.keuringsdatum.formatted).format('DD-MM-YYYY') : 'geen'
                  }}
                </b-input-group-text>
              </b-input-group>
              
              <b-input-group 
                prepend="Keuringsstatus" 
                class="ml-3"
              >
                <b-input-group-text 
                  dark
                >
                  {{ parsing.ParsedPayload.isGoedgekeurd }}
                </b-input-group-text>
              </b-input-group>
            </b-button-toolbar>
            <b-card v-if="unit !== null">
              <b-button 
                class="pull-right" 
                variant="danger" 
                @click="unit = null"
              >
                <font-awesome-icon icon="times" /> Unit selectie verwijderen
              </b-button>
              <b-card-title>
                {{ unit.titel }} {{ unit.unitkenmerk }}
              </b-card-title>
              <b-card-sub-title>
                {{ unit.adres }} <small>{{ unit.lokatiehint }}</small><br>
                {{ unit.postcode }} {{ unit.plaats }}
              </b-card-sub-title>

              <b-input-group 
                :prepend="unit.keuringsinstantie" 
                class="my-3"
              >
                <b-input-group-text dark>
                  {{
                    unit.keuringsnummer
                  }}
                </b-input-group-text>
              </b-input-group>

              <b-input-group 
                class="mb-3" 
                prepend="Keuringsstatus unit"
              >
                <b-radio-group
                  v-model.number="unit.keuringsstatus"
                  :options="keuringstatusActueel"
                  :button-variant="statusVariant"
                  :variant="statusVariant"
                  buttons
                />

                <b-input-group-text>Keuringsdatum</b-input-group-text>
                <b-input-group-append>
                  <DateInputField v-model="unit.keuringsdatum" />
                </b-input-group-append>
                <b-input-group-append
                  v-if="moment(unit.keuringsdatum).add(unit.geldigheidkeuringmaanden, 'M') < new Date()"
                >
                  <b-input-group-text class="bg-warning text-dark">
                    Verlopen {{ moment(unit.keuringsdatum).add(unit.geldigheidkeuringmaanden, "M").format("DD-MM-YYYY") }}
                  </b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-card>
            
            <b-table
              v-else 
              :items="units"
              :fields="[
                'unitkenmerk',
                'adres',
                'keuringsdatum',
                'keuringsstatus',
                'keuringsnummer'
              ]"
              :caption="tableCaption"
              show-empty
              responsive
              selectable
              dark
              select-mode="single"
              striped
              empty-text="Geen units gevonden op basis van de gegevens in het keuringsrapport"
              hover
              bordered
              small
              @row-clicked="unit = $event"
            >
              <template #cell(keuringsdatum)="data">
                {{ moment(data.item.keuringsdatum).format("DD-MM-YYYY") }}
              </template>
              <template #cell(keuringsstatus)="data">
                {{
                  keuringstatus.find(
                    o => o.value == data.item.keuringsstatus
                  ).text
                }}
              </template>
              <template #cell(adres)="data">
                {{ data.item.adres }}<br>
                {{ data.item.postcode }} {{ data.item.plaats }}
              </template>
            </b-table>
            
            <b-input-group v-if="unit == null">
              <b-input 
                v-model="search" 
                :disabled="searching"
                type="search" 
                placeholder="Zoek unit op basis van adres, plaats, kenmerk, etc." 
              />
              <b-input-group-append>
                <b-button 
                  :disabled="searching" 
                  variant="primary" 
                  @click="searchUnits"
                >
                  <b-spinner 
                    v-if="searching"
                    show 
                    small
                  />
                  <font-awesome-icon 
                    v-else 
                    icon="search"
                  /> Zoeken
                </b-button>
              </b-input-group-append>
            </b-input-group>
            <b-form-group 
              v-else 
              description="Deze omschrijving wordt overgenomen bij verwerking van de keuring" 
              label="Omschrijving"
            >
              <b-textarea 
                v-model="omschrijving" 
                placeholder="Bijvoorbeeld: Herkeuring, modificatiekeuring, etc."
              />
            </b-form-group>
          </b-card-body>
        </b-card>

        <b-card style="z-index:0;height:70vh;">
          <vue-pdf-app
            :pdf="pdfProxyUrl"
            :file-name="parsing.ParsedPayload.file_name"
            theme="dark"
          />
        </b-card>
      </b-card-group>

      <b-card-footer>
        <b-button
          :disabled="unit == null"
          variant="primary"
          class="pull-right"
          @click="ProcessParsing"
        >
          Verwerk keuring  <font-awesome-icon icon="play" />
        </b-button>
        
        <b-button 
          variant="ghost" 
          class="text-danger" 
          @click="DeleteParsing"
        >
          <font-awesome-icon icon="trash" /> Verwijderen
        </b-button>
        <b-form-group
          class="pull-right mr-4"
          description=""
        >
          <b-checkbox 
            v-model="opmerkingen_toevoegen" 
            switch 
            class="mt-2"
          >
            Opmerkingen invoeren na verwerking
          </b-checkbox>
        </b-form-group>
      </b-card-footer>
    </b-card>
    <div v-else>
      Loading...
    </div>
  </b-overlay>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import { keuringMixin } from "@/mixins/keuringMixin"; 
import VuePdfApp from "vue-pdf-app";
import DateInputField from "@/components/DateInputField.vue";
import "vue-pdf-app/dist/icons/main.css";

export default {
  name: "Parsing",
  components: {
    VuePdfApp,
    DateInputField,
},
  mixins: [serviceMixin, keuringMixin],
  beforeRouteUpdate(to, from, next) {
    if (to.params.id != from.params.id) this.getParsing(to.params.id);
    next();
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      units: [],
      searching: false,
      tableCaption: "Units op basis van de gegevens in het keurinsrapport",
      unit: null,
      busy: false,
      search: null,
      omschrijving: null,
      opmerkingen_toevoegen: false,
      parsing: null
    };
  },
  computed: {
    pdfProxyUrl() {
      const baseUrl = process.env.VUE_APP_TPA_API_URL.replace(/\/$/, '');
      return `${baseUrl}/docparser/parsing/${this.$route.params.id}/pdf`;
    },
    isStatus: function() {
      var tag = this.parsing.ParsedPayload.isGoedgekeurd;
      if (tag == null) return -1; // geen status (nog) bekend
      if (tag.toLowerCase().includes("met opmerkingen")) return 1;
      if (tag.toLowerCase().includes("goedgekeurd")) return 1;
      if (tag.toLowerCase().includes("afgekeurd")) return 0;
      return -1;
    },
    
    keuringstatusActueel: function() {
      return this.keuringstatus.filter(el => el.value !== -3);
    },  
    statusVariant: function() {
      // variant met outline
      if (this.unit == null) return "outline-secondary";
     
      var status = this.unit.keuringsstatus;
      return "outline-" + this.keuringcolor[status+3];
    }
  },
  watch: {
    units: function(val) {
      if (val.length == 1) this.$set(this,"unit",Object.assign({}, val[0]));
    },
    unit: function(val) {
      console.log("huidige unit", val);
    }
  },
  mounted() {
    this.getParsing(this.$route.params.id);
  },
  methods: {
    overnemenresultaat() {
      this.unit.keuringsstatus = this.isStatus;
      this.unit.keuringsdatum = this.parsing.ParsedPayload.keuringsdatum.formatted;
    },
    cerificaat(status) {
      return this.keuringsstatus.find(el => el.value == status).text;
    },
    searchUnits() {
      this.searching = true;
      this.get(`/docparser/unit/search?querystring=${this.search}`).then((response) => {
        console.log(response.data);
        if (response.data.result.length < 15) {
          this.tableCaption = `Units op basis van zoekopdracht: ${this.search}`;
          this.units = response.data.result;
        } else if (response.data.result.length == 0) {
          this.tableCaption = `Geen units gevonden op basis van zoekopdracht: ${this.search}`;
        } else {
          this.tableCaption = `Te veel units gevonden ( 15 of meer ) op basis van zoekopdracht: ${this.search}`;
        }
      }).catch((error) => {
        console.log(error);
      }).finally(() => {
        this.searching = false;

    })},
    ProcessParsing() {
      var vm = this;
      this.busy = true
      this.post(`/docparser/parsing/${this.$route.params.id}/verwerken`, {
        unit: this.unit,
        omschrijving: this.omschrijving,
        opmerkingen_toevoegen: this.opmerkingen_toevoegen,
      })
        .then(function(response) {
          // new document route 'doc/id/opmerkingen' of 'docparser-parsings'
          vm.$router.push(response.data.route);
        })
        .catch(function(error) {
          console.log("error");
          console.log(error);
        }).finally(() => {
          this.busy = false
        });
    },
    DeleteParsing() {
      console.log("document word verwijderd!");
      var vm = this;
      this.delete(`/docparser/parsing/${this.$route.params.id}`)
        .then(function(response) {
          console.log(response.data);
          vm.$router.push({
            name: "docparser-parsings",
          });
        })
        .catch(function(error) {
          console.log("error");
          console.log(error);
        });
    },
    getParsing(id) {
      var vm = this;
      this.busy = true;
      this.parsings = [];
      this.get(`/docparser/parsing/${id}`)
        .then(function(response) {
          console.log(response.data);
          vm.parsing = response.data.result;
          vm.units = response.data.units;
        })
        .catch(function(error) {
          console.log("error");
          console.log(error);
        })
        .finally(function() {
          vm.busy = false;
        });
    }
  }
};
</script>
